import React, { useState, useEffect, useRef } from "react";
import CityDropdown from "./CityDropdown";
import "./PropertySearch.css";

const RENT_PRICES = [20000, 30000, 40000, 50000, 60000, 80000, 100000, 150000, 200000, 300000, 500000, 1000000];
const BUY_PRICES = [300000, 500000, 800000, 1000000, 1500000, 2000000, 3000000, 5000000, 8000000, 10000000];

const RESIDENTIAL_TYPES = ["Apartment","Villa","Townhouse","Penthouse","Hotel Apartment","Land Residential","Residential Building"];
const COMMERCIAL_TYPES = ["Office","Shop","Showroom","Warehouse","Commercial Villa","Land Commercial","Commercial Building","Commercial Floor","Factory","Labour Camp","Industrial Land","Mixed Use Land"];

const PropertySearchControl = ({ defaultValues, onSearch }) => {
  // 🔹 State
  const [offerType, setOfferType] = useState("Sale");
  const [city, setCity] = useState(null);
  const [propertyCategory, setPropertyCategory] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [beds, setBeds] = useState("");
  const [baths, setBaths] = useState("");
  const [minArea, setMinArea] = useState("");
  const [maxArea, setMaxArea] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const [showBedsPopup, setShowBedsPopup] = useState(false);
  const [showAreaPopup, setShowAreaPopup] = useState(false);
  const [showPricePopup, setShowPricePopup] = useState(false);

  const bedsRef = useRef(null);
  const areaRef = useRef(null);
  const priceRef = useRef(null);

  const priceOptions = offerType === "Rent" ? RENT_PRICES : BUY_PRICES;

  // 🔹 Sync state with defaultValues on prop change
  useEffect(() => {
    setOfferType(defaultValues?.offering_type === "Rent" ? "Rent" : "Sale");
    setCity(defaultValues?.city ? { value: defaultValues.city, label: defaultValues.city } : null);
    setPropertyCategory(defaultValues?.property_category || "");
    setPropertyType(defaultValues?.property_type || "");
    setBeds(defaultValues?.bedrooms || "");
    setBaths(defaultValues?.bathrooms || "");
    setMinArea(defaultValues?.minArea || "");
    setMaxArea(defaultValues?.maxArea || "");
    setMinPrice(defaultValues?.minPrice || "");
    setMaxPrice(defaultValues?.maxPrice || "");
  }, [defaultValues]);

  // 🔹 Close popups on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        bedsRef.current && !bedsRef.current.contains(e.target) &&
        areaRef.current && !areaRef.current.contains(e.target) &&
        priceRef.current && !priceRef.current.contains(e.target)
      ) {
        setShowBedsPopup(false);
        setShowAreaPopup(false);
        setShowPricePopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 🔹 Search handler
 // 🔹 Search handler
const handleSearchClick = () => {
  const payload = {
    offering_type: offerType,
    city: city?.value || "",
    property_category: propertyCategory,
    property_type: propertyType,
    bedrooms: beds,
    bathrooms: baths,
    minArea,
    maxArea,
    minPrice,
    maxPrice
  };

  onSearch(payload);
};


  return (
    <div className="search-container">
      {/* TOP ROW */}
      <div className="search-top">
        <div className="buy-rent-toggle">
          <button
            className={offerType === "Sale" ? "active toggel-first" : "toggel-first"}
            onClick={() => setOfferType("Sale")}
          >
            Buy
          </button>
          <button
            className={offerType === "Rent" ? "active toggel-last" : "toggel-last"}
            onClick={() => setOfferType("Rent")}
          >
            Rent
          </button>
        </div>

        <div className="location-box">
          <CityDropdown value={city} onChange={setCity} />
        </div>

        <button className="search-main-btn" onClick={handleSearchClick}>
          Search
        </button>
      </div>

      {/* FILTERS */}
      <div className="search-filters">
        <select value={propertyCategory} onChange={(e) => {
          setPropertyCategory(e.target.value);
          setPropertyType("");
        }}>
          <option value="">All</option>
          <option value="Residential">Residential</option>
          <option value="Commercial">Commercial</option>
        </select>

        <select value={propertyType} onChange={(e) => setPropertyType(e.target.value)}>
          <option value="">Property Type</option>
          {(propertyCategory === "Residential"
            ? RESIDENTIAL_TYPES
            : propertyCategory === "Commercial"
              ? COMMERCIAL_TYPES
              : [...RESIDENTIAL_TYPES, ...COMMERCIAL_TYPES]).map(t => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>

        {/* BEDS & BATHS */}
        <div className="popup-wrapper  price-input" ref={bedsRef}>
          <button className="popup-trigger" onClick={() => {
            setShowBedsPopup(!showBedsPopup);
            setShowAreaPopup(false);
            setShowPricePopup(false);
          }}>
            {beds || baths ? `${beds || 0} Beds • ${baths || 0} Baths` : "Beds & Baths"}
          </button>

          {showBedsPopup && (
            <div className="popup-card-price">
              <div className="popup-row">
                <span>Beds</span>
                <select value={beds} onChange={(e) => setBeds(e.target.value)}>
                  <option value="">Any</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="5+">5+</option>
                </select>
              </div>

              <div className="popup-row">
                <span>Baths</span>
                <select value={baths} onChange={(e) => setBaths(e.target.value)}>
                  <option value="">Any</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="5+">5+</option>
                </select>
              </div>

              <button className="popup-apply" onClick={() => setShowBedsPopup(false)}>
                Apply
              </button>
            </div>
          )}
        </div>
        {/* AREA */}
       <div className="popup-wrapper price-input" ref={areaRef}>
          <button className="popup-trigger" onClick={() => {
            setShowAreaPopup(!showAreaPopup);
            setShowBedsPopup(false);
            setShowPricePopup(false);
          }}>
            {minArea || maxArea ? `${minArea || 0} - ${maxArea || "Any"} Sqft` : "Area"}
          </button>

          {showAreaPopup && (
            <div className="popup-card-price">
              <div className="popup-row">
                <span>Min Area (Sqft)</span>
                <input type="number" min={100} value={minArea} onChange={(e) => setMinArea(e.target.value)} />
              </div>

              <div className="popup-row">
                <span>Max Area (Sqft)</span>
                <input type="number" min={100} value={maxArea} onChange={(e) => setMaxArea(e.target.value)} />
              </div>

              <button className="popup-apply" onClick={() => setShowAreaPopup(false)}>
                Apply
              </button>
            </div>
          )}
        </div>

        {/* PRICE */}
        <div className="popup-wrapper price-input" ref={priceRef}>
          <button className="popup-trigger" onClick={() => {
            setShowPricePopup(!showPricePopup);
            setShowBedsPopup(false);
            setShowAreaPopup(false);
          }}>
            {minPrice || maxPrice
              ? `AED ${minPrice || priceOptions[0]} - ${maxPrice || "Any"}${offerType === "Rent" ? " / year" : ""}`
              : `Price (AED${offerType === "Rent" ? " / Year" : ""})`}
          </button>

          {showPricePopup && (
            <div className="popup-card-price">
              <div className="popup-row">
                <span>Min Price</span>
                <select value={minPrice} onChange={(e) => setMinPrice(e.target.value)}>
                  <option value="">Any</option>
                  {priceOptions.map(p => (
                    <option key={p} value={p}>{p.toLocaleString()}</option>
                  ))}
                </select>
              </div>

              <div className="popup-row">
                <span>Max Price</span>
                <select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
                  <option value="">Any</option>
                  {priceOptions.map(p => (
                    <option key={p} value={p}>{p.toLocaleString()}</option>
                  ))}
                </select>
              </div>

              <button className="popup-apply" onClick={() => setShowPricePopup(false)}>
                Apply
              </button>
            </div>
          )}
        </div>
         <button className="search-mobile-btn" onClick={handleSearchClick}>
          Search
        </button>
      </div>
    </div>
  );
};

export default PropertySearchControl;
